<template>
  <div class="stuHome">
    <div class="pubBg">
      <div class="stuHeader">
        <div>
          <img :src="logoSrc" alt="" id="logo" class="logoImg" />
          <h2>&nbsp;|&nbsp;{{ CustomForm.systemName }}</h2>
        </div>

        <!-- $route.name !== 'batch'" -->
        <div class="go-batch" @click="goBatch" v-if="noNeedBack.indexOf($route.name) === -1">
          <img src="@/assets/img/go-batch-icon.png" alt="" />
          <span>返回批次</span>
        </div>
        
        <div class="nav" v-if="hidNavList.indexOf(pageName) === -1">
          <span
            :class="{ activeNav: pageName === item.name }"
            v-for="(item, index) in navList"
            :key="index"
            @click="handleNav(item.name)"
            v-show="item.name == 'ticket' ? downloadEntrance == 1 : item.show ? true: false"
          >
            {{ item.title }}
          </span>
        </div>

        <div class="user" v-if="isShowUser">
          <el-dropdown style="width: 100%;">
            <span class="el-dropdown-link">
              {{ userName }} 
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goUserConfig">账号设置</el-dropdown-item>
              <el-dropdown-item @click.native="outLogin">安全退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <div class="QRCode" @click="showQRCode">
            <img src="@/assets/img/QRCode_icon.png" alt="">
            <p>扫码推送消息</p>
          </div> -->
        </div>
      </div>

      <div class="stuMain">
        <!-- @home-needPayment="getPayment" -->
        <!-- @home-planInfo="homePlanInfo" -->
        <router-view
          @home-flag="homeFlag"
          :userInfo="userInfo"
          :schoolInfo="schoolInfo"
        ></router-view>
        <copyright class="copyright" />
      </div>

      <!-- <ots-custom-dialog :dialog.sync="showQRCodeDialog" title="扫码推送消息" width="30%">
        <template v-slot:content>
          <div class="exportDialog" >
            <img src="@/assets/img/WxQRCode.jpeg" alt="" style="margin: 0 auto;display: block;">
            <p style="text-align: center;">扫码关注公众号，及时接收消息推送。</p>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="showQRCodeDialog = false">关闭</el-button>
        </template>
      </ots-custom-dialog> -->
    </div>
  </div>
</template>

<script>
import { selectByOne } from "@/http/modules/custom";
import { getSinglePlan } from "@/http/modules/examSet/examBatch";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import logoSet from "@/http/logoSet.js";
import { logoDefault } from "@/http/logoSet.js";
import copyright from "../../components/copyright.vue";
export default {
  components: { copyright },
  name: "stuHome",
  data() {
    return {
      CustomForm: {
        systemName: "弘成慧考平台",
      },
      logoSrc: "",
      userName: "",
      pageName: "",
      isShowUser: false,
      // 隐藏路由
      hidNavList: [
        "register",
        "resetPassword",
        "payTransfer",
        "updatePassword",
        "batch",
        "userConfig"
      ],
      noNeedBack: [
        "batch",
        "userConfig",
        "register"
      ],
      // 批次信息
      planInfo: {},
      // 用户信息
      info: {},
      // 用户信息(接口不同)
      userInfo: {},
      // 院校信息
      schoolInfo: [],
      // 是否需要缴费
      // needPayment: '',
      // 导航标题
      navList: [
        {
          title: "首页",
          name: "home",
          show: true,
        },
        {
          title: "报名",
          name: "stuApply",
          show: true,
        },
        {
          title: "缴费",
          name: "payFee",
          show: true,
        },
        {
          title: "准考证",
          name: "ticket",
          show: true,
        },
        {
          title: "考试",
          name: "stuExam",
          show: true,
        },
        {
          title: "成绩",
          name: "stuScore",
          show: true,
        },
        {
          title: "公告",
          name: "stuNotice",
          show: true,
        },
      ],
      // 获取当前时间
      currentTime: "",
      // 是否开启准考证
      downloadEntrance: 0,

      isPassWordExpired: 0,

      showQRCodeDialog: false,

      SignUpInfo: {},
      hasPhoneOrEmailCount: false,
    };
  },




  computed: {
    /*****************************
     * @isSignUp 能报名--true
     *****************************/
    isSignUp() {
      let { beginSign, endSign, isUseLastPlan, isPlanRegion } = this.planInfo;
      // 时间格式转换, 兼容 ios
      beginSign = beginSign.replace(/\-/g, "/");
      endSign = endSign.replace(/\-/g, "/");
      let { flag } = this.info;
      let currentTime = this.currentTime;
      beginSign = new Date(beginSign).getTime();
      endSign = new Date(endSign).getTime();

      if (
        currentTime >= beginSign &&
        currentTime <= endSign &&
        (flag === 0 || flag === null || flag === 3 || flag === 1) &&
        !isUseLastPlan &&
        isPlanRegion == "1"
      ) {
        return true;
      } else {
        return false;
      }
    },

    /*****************************
     * @isGoPay 能否去缴费
     *****************************/
    isGoPay() {
      let { flag } = this.info;
      let { startPay, endPay } = this.planInfo;
      startPay = startPay ? startPay.replace(/\-/g, "/") : "";
      endPay = endPay ? endPay.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let startPayTime = new Date(startPay).getTime();
      let endPayTime = new Date(endPay).getTime();
      // 缴费时间范围内, 才可以去缴费
      if ( (flag === 2 || flag === 5) && currentTime < endPayTime && currentTime > startPayTime ) {
        return true;
      } else {
        return false;
      }
    },

    isGoTicket() {
      let { flag } = this.info;
      let { isPayCourse } = this.SignUpInfo;
      let { beginEntrance, endExam } = this.planInfo;
      beginEntrance = beginEntrance ? beginEntrance.replace(/\-/g, "/") : "";
      endExam = endExam ? endExam.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let beginEntranceTime = new Date(beginEntrance).getTime();
      let endExamTime = new Date(endExam).getTime();
      console.log("stuHomeFlag", flag);
      if ((flag == 5 || flag == 6 || flag == 7 || (flag == 2 && isPayCourse == 1)) && currentTime >= beginEntranceTime && currentTime < endExamTime) {
        return true;
      } else {
        return false;
      }
    }


  },

  methods: {
    showQRCode() {
      this.showQRCodeDialog = true;
    },

    /**
     * @param { 查询批次信息 }
     */
    async getPlanInfo(){
      let planId = window.sessionStorage.getItem("planId");

      if (!planId || planId == 'undefined') {
        return;
      }

      const { data, code } = await getSinglePlan({planId});
      if (code === 0) {
        return;
      }
      this.navList.map(e=>{
        if (e.name == "stuExam") {
          e.title = data.examBeginAndEndCustomName ? data.examBeginAndEndCustomName: "考试";
        }
      })
      this.downloadEntrance = data.downloadEntrance ? data.downloadEntrance: '';
      if (this.$route.name != "register" && this.$route.name != "resetPassword") {
        this.navList.map((e, i)=>{
          if (data.isPay != 1 && e.name == 'payFee') {
            this.navList[i].show = false;
          } else if (data.examTypeId == 4 && e.name == "stuExam") {
            this.navList[i].show = false;
          } else if (data.allowViewExamTimeFlag == 1 && e.name == "stuExam") {
            this.navList[i].show = false;
          } else if(data.allowViewExamScoreFlag == 1 && e.name == "stuScore") {
            this.navList[i].show = false;
          } else {
            this.navList[i].show = true;
          }
        })
      }

    },

    /**
     * @param { 改菜单 }
     */
    // homePlanInfo(data) {
    //   this.planInfo = data;
    // },

    //返回批次列表
    goBatch() {
      this.$router.push({
        name: "batch",
      });
    },
    /**********************************************
     * @getCustomSet 个性化LOGO,系统名设置
     **********************************************/
    getCustomSet() {
      let tenant = window.localStorage.getItem("tenant");
      let defaultLogo = require("@/assets/img/customDefault.png");
      this.$api.system.getSystemNameFN({ tenant }).then(({ data }) => {
        this.CustomForm.systemName = data.systemName
          ? data.systemName
          : "弘成慧考平台";
        this.logoSrc =
          data.isUsedLogo == 1
            ? data.logoUrl
              ? data.logoUrl
              : defaultLogo
            : defaultLogo;
        this.hasPhoneOrEmailCount = data.baseDefList.filter(item=>item.fieldName=='phone' || item.fieldName=='email').filter(item=>item.required==1).length;
      });
    },

    /***********************************
     * @getSelectByOne 查询当前用户个人信息
     * - 新增: 判断当前用户是否可以报名(非历史批次,存在当前考生范围内)
     ***********************************/
    async getSelectByOne() {
      const res = await selectByOne();
      this.userInfo = res.data;
      this.userName = res.data.realName;
      this.schoolInfo = [];
      this.userInfo.extData.map((e) => {
        if (e.title == 2 && e.type != "textarea" && e.type != "imageUpload") {
          this.schoolInfo.push(e);
        }
      });
      this.userInfo.photo = null;
      const { data } = await getCurrentPlanFn({ cardNo: res.data.cardNo, planId: window.sessionStorage.getItem("planId") })
      this.planInfo = data;
      const { data: SignUpInfo } = await this.$api.applyManage.selectOneSignUp({ planId: window.sessionStorage.getItem("planId"), stuIds: res.data.id });
      this.SignUpInfo = SignUpInfo;


      return;
      selectByOne().then((res) => {
        this.userInfo = res.data;
        this.userName = res.data.realName;
        this.schoolInfo = [];
        this.userInfo.extData.map((e) => {
          if (e.title == 2 && e.type != "textarea" && e.type != "imageUpload") {
            this.schoolInfo.push(e);
          }
        });
        this.userInfo.photo = null;
        return getCurrentPlanFn({
          cardNo: res.data.cardNo,
          planId: window.sessionStorage.getItem("planId"),
        });
      }).then(({data})=>{
        this.planInfo = data;
        // this.navList   stuExam
      })
    },

    /*************************
     * @homeFlag 接收home传的falg
     *************************/
    homeFlag(flag) {
      if (
        this.$route.name != "register" &&
        this.$route.name != "resetPassword"
      ) {
        this.info.flag = flag;
      }
    },

    /*****************************
     * @homeNeedPayment 是否开启缴费
     *****************************/
    // getPayment(Payment){
    //   this.needPayment = Payment;
    //   if (Payment != 1) {
    //     this.navList.map( (e, i) => {
    //       if (e.name == 'payFee') {
    //         this.navList.splice(i, 1);
    //         return false;
    //       }
    //     })
    //   } else {
    //     return;
    //   }
    // },

    /*****************************
     * @getLogo 获取 Logo 链接 (弃用)
     *****************************/
    // getLogo () {
    //   let tenant = window.localStorage.getItem('tenant')
    //   if (!tenant) {
    //     tenant = this.$route.query.tenant
    //   }
    //   logoSet('stu', tenant).then(({ code, data }) => {
    //     if (code == 1) {
    //       this.logoSrc = data
    //     } else {
    //       this.logoSrc = logoDefault('stu')
    //     }
    //   }).catch(() => {
    //     this.logoSrc = logoDefault('stu')
    //   })
    // },

    /******************************
     * @handleNav 报名/缴费 是否可跳转
     ******************************/
    handleNav(name) {
      if (name === "stuApply" && !this.isSignUp) {
        this.$message.warning("当前不能报名~");
        return;
      } else if (name === "payFee" && !this.isGoPay) {
        this.$message.warning("当前无法缴费~");
        return;
      } else if (name == "ticket" && !this.isGoTicket) {
        this.$message.warning("当前无法下载准考证~");
        return;
      }
      this.$router.push({ name: name });
    },

    /*******************************
     * @getPageName 获取路由名
     *******************************/
    getPageName() {
      this.pageName = this.$route.name;
    },

    /*******************************
     * @goUserConfig 账号设置
     *******************************/
    goUserConfig() {
      if(this.hasPhoneOrEmailCount > 0){
        this.$router.push({
          name: "userConfig",
        });
      }else{
        this.$message.error('当前不允许修改账号信息');
        return;
      }
    },

    /*******************************
     * @outLogin 退出登录
     *******************************/
    outLogin() {
      this.mixin_outLogin();
    },

    /* ** getCurrentTime(获取当前时间) ** */
    getCurrentTime() {
      this.mixin_getServerTime().then(({ data }) => {
        this.currentTime = new Date(
          data ? data.replace(/\-/g, "/") : ""
        ).getTime();
      });
    },

    // 密码到期：是否必须修改密码
    isMustRestPSD(){
      let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      this.isPassWordExpired = userInfo.isPassWordExpired;
      if (this.isPassWordExpired == 1) {
        this.$router.push({ name: "userConfig" });
      }
    },
  },
  created() {
    if (this.$route.name != "register" && this.$route.name != "resetPassword") {
      this.isShowUser = true;
      this.getSelectByOne();
      this.getCurrentTime();
    }
  },
  mounted() {
    this.getPageName();
    this.getCustomSet();
    if (this.$route.name != "register" && this.$route.name != "resetPassword") {
      this.getPlanInfo();
      // 密码到期：是否必须修改密码
      this.isMustRestPSD();
    }
  },
  watch: {
    $route: function (value) {
      this.getSelectByOne();
      this.getPageName();
      this.getPlanInfo();
      // 密码到期：检测路由变动，是否必须修改密码
      this.isMustRestPSD();
    },
  },
};
</script>
<style lang="less" scoped>
.logoImg {
  max-width: 100%;
  max-height: 42px;
}
.go-batch {
  margin-left: 72px;
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
  span {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    margin-left: 8px;
  }
}
.stuHome {
  height: 100%;
  min-width: 1240px;
  background: #f4f5f8;
  position: relative;
  .pubBg {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    background: url("../../assets/stuImg/pubBg.jpg") no-repeat top center;
    background-size: 100% 360px;
    display: flex;
    flex-direction: column;
    .stuHeader {
      & > div {
        display: flex;
      }
      display: flex;
      padding: 10px 30px 0 30px;
      justify-content: space-between;
      h2 {
        color: #fff;
        line-height: 42px;
        font-size: 18px;
      }
    }
    .nav {
      display: inline-block;
      vertical-align: top;
      color: #fff;
      flex: 1;
      margin-left: 50px;
      span {
        display: inline-block;
        vertical-align: top;
        height: 40px;
        line-height: 40px;
        margin-right: 60px;
        color: rgba(255, 255, 255, 0.75);
        font-size: 16px;
        cursor: pointer;
      }
      .activeNav {
        color: #fff !important;
        font-weight: 600 !important;
      }
    }
    .user {
      height: 40px;
      line-height: 40px;
      color: #fff;
      position: relative;
      .QRCode {
        cursor: pointer;
        width: 120px; 
        height: 36px; 
        color: #FFF; 
        text-align: right; 
        position: absolute; 
        left: 0px; 
        top: 48px;
        transform: translate(-50%); 
        display: flex; 
        align-items: center;
        img {
          width: 16px; 
          height: 16px; 
          margin-right: 8px;
        }
      }

    }
  }
  .stuMain {
    position: relative;
    width: 1240px;
    margin: 0 auto;
    margin-top: 78px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 18px;

    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 68px;
      background: #ffffff;
      box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.06);
      border-radius: 0px 0px 8px 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
/deep/ .el-dropdown {
  color: #fff;
}
/* 针对 IE 的版权样式(IE 8~ ) */
.copyright {
  text-align: center\0;
  margin-top: 280px\0;
  padding-bottom: 18px\0;
}
/* 针对 IE 样式 , 用 white 不用 #fff */
/deep/ .stu-foot {
  background-color: white\0;
}
</style>
